export default __webpack_public_path__ + "static/aaron_portrait-bde177ce3b4ccb9f297ce11d6167429f.jpg";